import './index.less'
import React from 'react'

const reloadPage = () => {
  window.location.reload()
}

const ErrorPlaceholder = ({ message, getData = reloadPage }) => {
  return (
    <div className="error-placeholder">
      <div className='img'></div>
      <div className='error-msg'>{message}</div>
      <div className='retry-button' onClick={getData}>点击重试</div>
    </div>
  )
}

export default ErrorPlaceholder
